import BaseDevice from '../base.js'
import Switch from './switch.js'
import Point from './point.js'
export default class DeviceImage extends BaseDevice {

   static render = (device, scale = 1) => {


      const MODS = this.getMods(device.width)


      if (MODS < 2 || MODS > 12) return;
      const SWITCHES = MODS >= 4 ? 4 : MODS
      const switchSVG = Switch.render(device.width, SWITCHES);
      const pointSVG = Point.render();
      return this.getDevice(device, scale, pointSVG + switchSVG);
   }
}
